export const EndpointConfig = {
	apiUrl: process.env.REACT_APP_API_URL,
	hubspotLogin: "/api/hubspot/oauth/connect",
	hubAppConfig: "/api/hub-app/config",
	hubWhatsAppConfig: "/api/hub-app/whatsapp-config",
	hubAppConfigSender: "/api/hub-app/config-sender",
	hubAppConfigDLTEntityId: "/api/hub-app/config-dltentityId",
	hubAppContacts: "/api/hub-app/contacts",
	hubAppAllContacts: "/api/hub-app/contacts/all",
	hubAppMultipleContacts: "/api/hub-app/contacts/multiple",
	hubAppCompany: "/api/hub-app/company",
	hubAppDeal: "/api/hub-app/deal",
	hubAppTicket: "/api/hub-app/ticket",
	Campaign: "/api/value-first/campaign",
	VFSendSMS: "/api/value-first/send-sms",
	VFSendWhatsApp: "/api/value-first/send-whatsapp",
	VFTemplates: "/api/value-first/templates",
	VFSMSTemplates: "/api/value-first/sms-templates",
	VFWhatsAppTemplateSync: "/api/value-first/whatsapp-templates-sync",
	VFWhatsAppTemplates: "/api/value-first/whatsapp-templates",
	VFUpload: "/api/value-first/upload",
	Xl2JSONUpload: "/api/xl-json/upload",
	VFDeliveryLogs: "/api/delivery-logs",
	VFTemplateProperties: "/api/value-first/template_properties",
	whatsappfetchtemplates: "api/hubspot-workflow/whatsapp-templates",
	Login: "/api/login",
	Logout: "/api/logout",
	User: "/api/admin/user",
	UserActivate: "/api/admin/user/activate"
}
